/**
 * @author       yewon@zumper.com (Yewon Lee)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  createSettingInterface.ts
 */

import { BaseOptions, Settings } from './Settings'

export type CreateSettingMethod = <V>(key: string, value: V) => V
export type SetSettingMethod = (key: string, value: any) => void
export type GetSettingMethod = (key: string) => any

interface SettingInterface {
  createSetting: CreateSettingMethod
  getSetting: GetSettingMethod
  setSetting: SetSettingMethod
  freeze: () => void
  settings: Settings
}

export const createSettingInterface = (
  options?: BaseOptions
): SettingInterface => {
  const settings = new Settings(options)
  return {
    createSetting: settings.createSetting.bind(settings),
    getSetting: settings.getSetting.bind(settings),
    setSetting: settings.setSetting.bind(settings),
    freeze: settings.freeze.bind(settings),
    settings,
  }
}
